import React from 'react';
import { FaHandHolding, FaRupeeSign } from 'react-icons/fa';

const HandRupeeIcon = ({ className = 'w-6 h-6', ...props }) => (
  <span className={`relative inline-flex ${className}`} {...props}>
    <FaHandHolding className="w-full h-full text-current" />
    <FaRupeeSign className="absolute inset-0 m-auto w-4 h-4 text-current" />
  </span>
);

export default HandRupeeIcon;
